import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Box, Button, Menu, MenuItem} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {CommtracNode} from '../../../interfaces/CommtracNode';
import {buildHistoryReportUrl} from '../../../utils/historyReportUrl';
import AccessControl from '../../common/AccessControl';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  item?: CommtracNode;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onOpenItem?: Function;
  onOpenHistory?: Function;
  onDone?: () => void;
}

const CommtracNodeItemsEditButton = <T extends ComponentType = typeof Button>({
  item,
  component,
  componentProps,
  children,
  onOpenItem,
  onOpenHistory,
}: // onDone,
Props<T>) => {
  const Component = component ?? Button;

  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement>();
  const menuOpen = !!menuAnchorEl;

  return (
    <>
      <Component
        {...componentProps}
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
      >
        {children}
      </Component>

      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onBackdropClick={() => setMenuAnchorEl(undefined)}
      >
        <AccessControl permissions={[item?.employee_asset_id ? 'patch::/asset-human-type/:id' : 'patch::/asset-machine/:id']}>
          <MenuItem
            onClick={() => {
              onOpenItem?.(
                item?.employee_asset_id,
                item?.type === 'miner' ? 'employee' : 'asset',
                'update'
              );
              setMenuAnchorEl(undefined);
            }}
          >
            {`Edit ${item?.type === 'miner' ? 'Employee' : 'Asset'}`}
          </MenuItem>
        </AccessControl>
        <MenuItem
          onClick={() => {
            onOpenItem?.(
              item?.employee_asset_id,
              item?.type === 'miner' ? 'employee' : 'asset'
            );
            setMenuAnchorEl(undefined);
          }}
        >
          Info & Actions
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenHistory?.(
              item?.id,
              item?.type === 'miner' ? 'employee' : 'asset'
            );
            setMenuAnchorEl(undefined);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            gap={1}
          >
            <span>View History</span>
            <OpenInNewIcon
              fontSize="small"
              onClick={(event) => {
                event.stopPropagation();
                if (item?.id !== undefined && item?.id !== null) {
                  window.open(
                    buildHistoryReportUrl(
                      item?.type === 'miner' ? 'employee' : 'asset',
                      item.id
                    ),
                    '_blank',
                    'noopener,noreferrer'
                  );
                  setMenuAnchorEl(undefined);
                }
              }}
              aria-label="Open in new tab"
              sx={{cursor: 'pointer', color: 'text.secondary'}}
            />
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
};

export default CommtracNodeItemsEditButton;
